
<div class="w-screen absolute top-0 left-0 px-2 md:px-10 lg:px-40 xl:px-80 z-[3]">
  <div class="min-h-[calc(100dvh-385px)]">
    <div class="bg-white select-none rounded-[20px] mobile:w-[1301px] my-[70px] mx-auto pt-[35px] px-2 py-6 mobile:p-10"
      style="box-shadow: 0px 0px 6px #00000029;">
      <div class="w-full mx-auto mobile:w-[834px]">
        <img src="https://www.genius4u.it/wp-content/uploads/2025/02/genius4u-main-logo-2048x359.png" class="h-10 mx-auto">
        <div class="text-[22px] text-center mt-[29px] font-bold leading-[28px] text-[#d98b1f]">Riepilogo richiesta</div>
        <div class="text-[16px] text-center mt-[13px] leading-[19px] text-black">Controlla tutti i dati inseriti e procedi con la prenotazione e il pagamento.</div>
      </div>

<!-- calendario e fascia oraria -DA TOGLIERE, LASCIARE SOLO TITOLO-->

      <div class="mobile:flex gap-[25px] mt-5 mobile:mt-[52px]">
        <div class="w-full mx-auto mobile:w-[834px] min-h-[380px] pb-40 bg-[#FAFAFA] rounded-[16px] overflow-hidden">
          <div class="h-[61px] w-full px-2 text-[16px] leading-[19px] mobile:text-[24px] mobile:leading-[26px] font-bold bg-[#d98b1f] flex place-content-center items-center text-white">
            Riepilogo
          </div>

          @if(requestDetails){
          <div class="w-[80%] mx-auto">
            <div class="flex border-b-[1px] border-[#707070] py-5 gap-[10%]">
              <div class="w-[30%] text-[#44545D] font-bold text-[16px] leading-[19px]">Intervento richiesto</div>
              <div class="w-[60%] text-[#44545D] text-[16px] leading-[19px]">
                {{requestDetails.category}}</div>
              <!-- <div class="w-[10%]"><img src="icons/edit.svg"></div> -->
            </div>
            <div class="flex border-b-[1px] border-[#707070] py-5 gap-[10%]">
              <div class="w-[30%] text-[#44545D] font-bold text-[16px] leading-[19px]">Data e ora intervento</div>
              <div class="w-[60%] text-[#44545D] text-[16px] leading-[19px]">{{requestDetails.reserveDate}}</div>
              <!-- <div class="w-[10%]"><img src="icons/edit.svg"></div> -->
            </div>
            <div class="flex border-b-[1px] border-[#707070] py-5 gap-[10%]">
              <div class="w-[30%] text-[#44545D] font-bold text-[16px] leading-[19px]">Intestatario intervento</div>
              <div class="w-[60%] text-[#44545D] text-[16px] leading-[19px]">{{requestDetails.fullname}}</div>
              <!-- <div class="w-[10%]"><img src="icons/edit.svg"></div> -->
            </div>
            <div class="flex border-b-[1px] border-[#707070] py-5 gap-[10%]">
              <div class="w-[30%] text-[#44545D] font-bold text-[16px] leading-[19px]">Indirizzo intervento</div>
              <div class="w-[60%] text-[#44545D] text-[16px] leading-[19px]">{{requestDetails?.address?.address + ' ' +
                requestDetails?.address?.civic_number + ' - ' + requestDetails?.address?.cap + ' ' + requestDetails?.address?.city}}</div>
              <!-- <div class="w-[10%]"><img src="icons/edit.svg"></div> -->
            </div>
            @if(requestDetails.isDifferentAddress) {
              <div class="flex border-b-[1px] border-[#707070] py-5 gap-[10%]">
                <div class="w-[30%] text-[#44545D] font-bold text-[16px] leading-[19px]">Indirizzo di fatturazione</div>
                <div class="w-[60%] text-[#44545D] text-[16px] leading-[19px]">{{requestDetails?.fiscal_address?.address + ' ' +
                  requestDetails?.fiscal_address?.civic_number + ' - ' + requestDetails?.fiscal_address?.cap + ' ' + requestDetails?.fiscal_address?.city}}</div>
                <!-- <div class="w-[10%]"><img src="icons/edit.svg"></div> -->
              </div>
            }
            <div class="flex border-b-[1px] border-[#707070] py-5 gap-[10%]">
              <div class="w-[30%] text-[#44545D] font-bold text-[16px] leading-[19px]">Note</div>
              <div class="w-[60%] text-[#44545D] text-[16px] leading-[19px]">{{requestDetails.request_description}}</div>
       
            </div>
            <div class="flex border-b-[1px] border-[#707070] py-5 gap-[10%]">
              <div class="w-[30%] text-[#44545D] font-bold text-[16px] leading-[19px]">Prezzo</div>
              <div class="w-[60%] text-[#44545D] text-[16px] leading-[19px]">{{requestDetails.total | currency:'EUR'}}</div>
       
            </div>
          </div>
          }
          
          <div class="h-[51px] w-[239px] p-[2px] mx-auto mt-10"><div (click)="pay()" class="bg-[#d98b1f] text-white cursor-pointer flex font-bold items-center leading-19 text-center place-content-center rounded-[10px] size-full text-16 text-secondary"> Procedi al pagamento </div></div>
       </div>
      </div>
    </div>
  </div>
  </div>